import React from "react";

/**
 * Surface container used across every page.
 * Keeps border + radius + shadow consistent (subtle, non-cluttered).
 */
export default function Card({ children, className = "", as: Tag = "div", ...props }) {
    return (
        <Tag
            className={`rounded-2xl bg-white border border-slate-200/80 shadow-card
                dark:bg-slate-900 dark:border-slate-800 ${className}`}
            {...props}
        >
            {children}
        </Tag>
    );
}

export function CardHeader({ children, className = "", title, subtitle, action }) {
    if (title || subtitle || action) {
        return (
            <div className={`flex items-start justify-between gap-4 px-5 py-4 border-b border-slate-100 dark:border-slate-800 ${className}`}>
                <div className="min-w-0">
                    {title && (
                        <h3 className="text-sm font-semibold text-slate-900 dark:text-slate-100 truncate">{title}</h3>
                    )}
                    {subtitle && (
                        <p className="mt-0.5 text-xs text-slate-500 dark:text-slate-400">{subtitle}</p>
                    )}
                </div>
                {action && <div className="flex-shrink-0">{action}</div>}
            </div>
        );
    }
    return <div className={`px-5 py-4 border-b border-slate-100 dark:border-slate-800 ${className}`}>{children}</div>;
}

export function CardBody({ children, className = "" }) {
    return <div className={`p-5 ${className}`}>{children}</div>;
}
